import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import Carousel from '../../components/Carousel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  bannerImage: {
    overflow: 'hidden',
    position: 'relative'
  },
  textOnImage: {
    maxWidth: '60vw',
    color: '#ddd', 
    position: 'absolute', 
    bottom: '15%', 
    left: '10%',
  },
  prevButton: {
    backgroundColor: 'orange'
  },
  '@media screen and (min-width: 599px)': {
    bannerImage: {
      width: '100%',
      height: '100%',
      maxHeight: 'calc(90vh - 64px)',
    },
    carouselItem: {
      display: 'flex',
      padding: '20px 45px',
      justifyContent: 'center'
    }
  }
});

// placeholderImage: file(relativePath: { eq: "banner/banner1.jpg" }) {
const Banner = (props) => {
  const classes = useStyles();
  const bannerImages = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "banner"}}) {
        edges{
          node{
            base
              childImageSharp {
                fluid(quality: 100, maxWidth: 800) {
                  ...GatsbyImageSharpFluid
                }
              }
          }
        }
      }
    }
  `)

  return(
    <Carousel
      autoPlay={true}
      animation={'fade'}
      indicators={true}
      navButtonsAlwaysVisible={true}
      navButtonsProps={{
        style: classes.prevButton
      }}
      interval={5000}
      timeout={1500}
    >
      {
        bannerImages.placeholderImage.edges.map( (banner, index) => {
          return (
            <div key={index} className={classes.carouselItem}>
              <Img
                className={classes.bannerImage}
                fluid={banner.node.childImageSharp.fluid} />
            </div>
          )
        })
      }
    </Carousel>
  )
}

export default Banner;